<template>
  <div class="member-payment">
    <el-card class="payment-card">
      <template #header>
        <div class="card-header"><h2>会员支付</h2></div>
      </template>
      <div class="member-info-section">
        <h3>会员信息确认</h3>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="会员类型">{{ memberTypeText }}</el-descriptions-item>
          <el-descriptions-item label="会员等级" v-if="isIndividual">{{ memberLevelText }}</el-descriptions-item>
          <el-descriptions-item label="支付金额"><span class="amount">{{ amountText }}</span></el-descriptions-item>
          <el-descriptions-item label="有效期">1年</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="benefits-section">
        <h3>会员权益</h3>
        <el-alert type="success" :closable="false" show-icon>
          <template #title>
            <ul class="benefits-list">
              <li v-for="(benefit, index) in benefits" :key="index">{{ benefit }}</li>
            </ul>
          </template>
        </el-alert>
      </div>
      <div class="payment-method-section">
        <h3>支付方式</h3>
        <div class="payment-methods">
          <div class="payment-item" :class="{ active: selectedPaymentMethod === 'wechat' }" @click="selectPaymentMethod('wechat')">
            <img src="@/assets/images/weixin.png" alt="微信" class="payment-icon" />
            <span class="payment-name">微信支付</span>
          </div>
          <div class="payment-item" :class="{ active: selectedPaymentMethod === 'alipay' }" @click="selectPaymentMethod('alipay')">
            <img src="@/assets/images/alipay.png" alt="支付宝" class="payment-icon" />
            <span class="payment-name">支付宝支付</span>
          </div>
        </div>
      </div>
      <div class="action-buttons">
        <el-button size="large" @click="goBack">返回修改</el-button>
        <el-button type="primary" size="large" :disabled="!selectedPaymentMethod" @click="confirmPayment">确认支付</el-button>
      </div>
      
      <!-- 微信支付二维码区域 -->
      <div v-if="showQrcode" class="qrcode-section">
        <div class="qrcode-content">
          <h3>微信扫码支付</h3>
          <div class="qrcode-wrapper">
            <div v-if="qrcodeUrl" :key="qrcodeKey" ref="qrcodeRef" class="qrcode-canvas"></div>
            <div v-else class="qrcode-loading"><p>二维码生成中...</p></div>
          </div>
          <div class="qrcode-tips"><p>请使用微信扫描二维码完成支付</p></div>
          <div class="qrcode-actions">
            <el-button @click="cancelPayment">取消支付</el-button>
            <el-button type="primary" @click="handleWechatPaymentComplete">已完成支付</el-button>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from '@/api/index'
import QRCode from 'qrcodejs2-fix'
import {
  MEMBER_TYPE as MEMBER_TYPES,
  MEMBER_LEVEL as MEMBER_LEVELS,
  MEMBER_TYPE_NAMES,
  MEMBER_LEVEL_NAMES
} from '@/utils/constants'

export default {
  name: 'MemberPayment',
  data() {
    return {
      memberType: null,
      memberLevel: null,
      showQrcode: false,
      selectedPaymentMethod: null,
      qrcodeUrl: '',
      qrcodeKey: 0,
      paying: false
    }
  },
  computed: {
    isIndividual() {
      return this.memberType === MEMBER_TYPES.INDIVIDUAL
    },
    memberTypeText() {
      return MEMBER_TYPE_NAMES[this.memberType] || '-'
    },
    memberLevelText() {
      return MEMBER_LEVEL_NAMES[this.memberLevel] || '-'
    },
    amountText() {
      if (this.memberType === MEMBER_TYPES.INDIVIDUAL) {
        return this.memberLevel === MEMBER_LEVELS.NORMAL ? '¥100' : '¥300'
      }
      return '面议'
    },
    benefits() {
      var common = ['浏览课程信息', '购买课程']
      if (this.memberType === MEMBER_TYPES.INDIVIDUAL) {
        return this.memberLevel === MEMBER_LEVELS.REGISTERED
          ? common.concat(['个人信息展示', '优先参与活动'])
          : common
      }
      if (this.memberType === MEMBER_TYPES.ORGANIZATION) {
        return ['机构信息展示', '社会服务搜索', '查看完整会员信息']
      }
      if (this.memberType === MEMBER_TYPES.DIRECTOR) {
        return common.concat(['发布新闻', '管理新闻', '参与协会决策'])
      }
      return []
    }
  },
  mounted() {
    this.memberType = parseInt(this.$route.query.type)
    this.memberLevel = this.$route.query.level ? parseInt(this.$route.query.level) : null
    if (!this.memberType) {
      this.$message.error('参数错误')
      this.$router.push('/user/member-type-select')
    }
  },
  methods: {
    selectPaymentMethod: function(method) {
      this.selectedPaymentMethod = method
    },
    createWechatQRCode: async function() {
      this.qrcodeUrl = ''
      try {
        var res = await api.createPayment({
          payment_type: 1, // 支付类型：1-微信支付
          payment_method: 'native',
          year: new Date().getFullYear(),
          return_url: window.location.origin + '/payment-successful',
          remark: this.memberTypeText + '会员支付'
        })
        if (res && res.code === 2000) {
          // 使用 pay_data.code_url 字段获取微信支付二维码链接
          var codeUrl = res.data.pay_data && res.data.pay_data.code_url
          if (codeUrl) {
            this.qrcodeUrl = codeUrl
            this.qrcodeKey++
            // 等待 DOM 更新后再生成二维码
            await this.$nextTick()
            await this.$nextTick()
            this.generateQRCode(codeUrl)
          } else {
            this.$message.error('获取支付二维码失败')
          }
        } else {
          this.$message.error((res && res.msg) || '创建支付订单失败')
        }
      } catch (e) {
        console.error('创建微信支付订单失败:', e)
        this.$message.error('创建支付订单失败，请稍后重试')
      }
    },
    generateQRCode: function(url) {
      var container = this.$refs.qrcodeRef
      if (!container) {
        console.warn('二维码容器未找到，延迟重试')
        setTimeout(() => this.generateQRCode(url), 100)
        return
      }
      container.innerHTML = ''
      new QRCode(container, {
        text: url,
        width: 240,
        height: 240,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    confirmPayment: async function() {
      if (!this.selectedPaymentMethod) {
        this.$message.warning('请选择支付方式')
        return
      }
      
      if (this.selectedPaymentMethod === 'wechat') {
        // 微信支付：直接在页面下方显示二维码
        this.showQrcode = true
        await this.createWechatQRCode()
      } else if (this.selectedPaymentMethod === 'alipay') {
        // 支付宝支付：跳转到支付宝
        this.paying = true
        try {
          var res = await api.createPayment({
            payment_type: 2, // 支付类型：2-支付宝支付
            payment_method: 'page',
            year: new Date().getFullYear(),
            return_url: window.location.origin + '/payment-successful',
            remark: this.memberTypeText + '会员支付'
          })
          if (res && res.code === 2000) {
            var payData = res.data.pay_data
            if (payData) {
              // 打开支付宝支付页面
              window.open(payData, '_blank')
              // 提示用户完成支付后的操作
              this.$confirm('请在新窗口完成支付，支付完成后点击"已完成支付"按钮', '支付提示', {
                confirmButtonText: '已完成支付',
                cancelButtonText: '取消支付',
                type: 'info',
                closeOnClickModal: false
              }).then(() => {
                // 用户确认已完成支付
                this.clearPendingStorage()
                this.$message.success('支付确认成功，请稍后查看订单状态')
                this.$router.push('/user/home')
              }).catch(() => {
                // 用户取消支付
                this.$message.info('已取消支付')
              })
            } else {
              this.$message.error('获取支付链接失败')
            }
          } else {
            this.$message.error((res && res.msg) || '创建支付订单失败')
          }
        } catch (e) {
          console.error('创建支付宝订单失败:', e)
          this.$message.error('创建支付订单失败，请稍后重试')
        } finally {
          this.paying = false
        }
      }
    },
    handleWechatPaymentComplete: function() {
      // 微信支付完成
      this.showQrcode = false
      this.clearPendingStorage()
      this.$message.success('支付确认成功，请稍后查看订单状态')
      this.$router.push('/user/home')
    },
    cancelPayment: function() {
      // 取消支付
      this.showQrcode = false
      this.qrcodeUrl = ''
      this.$message.info('已取消支付')
    },
    clearPendingStorage: function() {
      localStorage.removeItem('pending_member_type')
      localStorage.removeItem('pending_member_level')
      localStorage.removeItem('member_info_completed')
    },

    goBack: function() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.member-payment {
  min-height: 100vh;
  padding: 40px 20px;
  background-color: #f5f7fa;

  .payment-card {
    max-width: 800px;
    margin: 0 auto;

    .card-header {
      text-align: center;
      h2 { margin: 0; font-size: 24px; color: #303133; }
    }

    .member-info-section,
    .benefits-section {
      margin-bottom: 30px;
      h3 { margin: 0 0 15px 0; font-size: 18px; color: #303133; }
      .amount { color: #f56c6c; font-size: 24px; font-weight: bold; }
    }

    .benefits-list {
      list-style: none;
      padding: 0;
      margin: 0;
      li { padding: 5px 0; }
      li::before { content: '✓ '; color: #67c23a; font-weight: bold; margin-right: 5px; }
    }

    .payment-method-section {
      margin-bottom: 30px;
      h3 { margin: 0 0 15px 0; font-size: 18px; color: #303133; }
      
      .payment-methods {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        gap: 20px;
        margin: 0 -10px;
        
        .payment-item {
          -webkit-box-flex: 1;
          -ms-flex: 1;
          flex: 1;
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          justify-content: center;
          gap: 12px;
          margin: 0 10px;
          padding: 20px;
          border: 2px solid #e4e7ed;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.2s;
          background-color: #fff;
          
          &:hover { 
            border-color: #409eff;
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
          }
          
          &.active { 
            border-color: #409eff; 
            background-color: #ecf5ff;
            box-shadow: 0 2px 12px rgba(64, 158, 255, 0.3);
          }
          
          .payment-icon { 
            width: 40px; 
            height: 40px; 
            object-fit: contain; 
          }
          
          .payment-name { 
            font-size: 16px; 
            font-weight: 500;
            color: #303133; 
          }
        }
      }
    }

    .action-buttons {
      display: flex;
      justify-content: center;
      gap: 20px;
      padding-top: 30px;
      border-top: 1px solid #e4e7ed;
    }
    
    .qrcode-section {
      margin-top: 30px;
      padding-top: 30px;
      border-top: 1px solid #e4e7ed;
      
      .qrcode-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        h3 {
          margin: 0 0 20px 0;
          font-size: 18px;
          color: #303133;
          text-align: center;
        }
        
        .qrcode-wrapper {
          width: 240px;
          height: 240px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          padding: 20px;
          background-color: #fff;
          border: 1px solid #e4e7ed;
          border-radius: 8px;
          
          .qrcode-canvas { 
            width: 240px; 
            height: 240px; 
          }
          
          .qrcode-loading { 
            text-align: center; 
            color: #909399; 
            p { 
              margin: 0; 
              font-size: 14px; 
            }
          }
        }
        
        .qrcode-tips {
          margin-bottom: 20px;
          p { 
            margin: 0; 
            font-size: 14px; 
            color: #606266;
            text-align: center;
          }
        }
        
        .qrcode-actions {
          display: flex;
          gap: 15px;
          justify-content: center;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .member-payment { 
    padding: 20px 10px; 
    
    .payment-card {
      .payment-method-section {
        .payment-methods {
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-direction: column;
          flex-direction: column;
          
          .payment-item {
            .payment-icon { width: 32px; height: 32px; }
            .payment-name { font-size: 15px; }
          }
        }
      }
    }
  }
}
</style>
